import { useParams } from "react-router-dom";
import { Landing, Quiz, Finding, Result, Share, Meet } from "./steps";

export function ColourMeMamaLanding() { return <Landing />; }

export function ColourMeMamaQuiz() {
  const { index } = useParams();
  return <Quiz index={index} />;
}

export function ColourMeMamaFinding() { return <Finding />; }
export function ColourMeMamaResult() { return <Result />; }
export function ColourMeMamaShare() { return <Share />; }
export function ColourMeMamaMeet() { return <Meet />; }
